<template>
    <b-container fluid>
        <div class="d-flex justify-content-center mb-5">
            <b-img src="img/banner_vecindapp.png"></b-img>
        </div>
        <b-row v-for="unit in units" :key="unit.id">
            <b-col class="my-3">
                <b-btn variant="primary" block @click="selectUnit(unit)">{{ unit.name }}</b-btn>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
export default {
    data: () => ({
        units: [],
    }),
    computed: {},
    methods: {
        selectUnit(unit) {
            this.setCurrentUnit(unit)
            this.next()
        },
        next() {
            if (this.$route.name === this.currentProfile.stop_login) {
                return this.$router.push({
                    name: this.currentProfile.default_screen,
                })
            }
            return this.$router.push({ name: 'selectVenuePage' })
        },
    },
    mounted() {
        if (this.currentClient.units.length === 1) {
            const unit = this.currentClient.units[0]
            this.setCurrentUnit(unit)
            return this.next()
        }
        this.units = this.currentClient.units
    },
}
</script>
